
<template>
    <my-drawer :show.sync="dialog.show" :title="dialog.edit ? '修改信息' : '新增信息'" @changeFullScreen="changeFullScreen">
        <div class="drawer-panel">
            <el-form ref="form" class="my-form" :model="dialog.form" :rules="rules" label-width="120px">
                <el-row>
                    <template v-for="(col, i) in cols">
                        <el-col :key="i" :span="!max||col.inline?24:12">
                            <el-form-item :key="i" :prop="col.key" :label="col.value"
                                          v-if="isShow(col)">
                                <slot :name="'slot_' + col.key" :col="col" :form="dialog.form">
                                    <template v-if="col.read && dialog.edit">
                                        <template v-if="col.keyShow">{{props.row[col.keyShow]}}</template>
                                        <template v-else-if="col.type === $variable.colType.SELECT">{{dialog.form[col.key + 'Name']}}
                                        </template>
                                        <template v-else>{{dialog.form[col.key]}}</template>
                                    </template>
                                    <template v-else-if="col.type === $variable.colType.SELECT">
                                        <my-select v-model="dialog.form[col.key]" :placeholder="`请选择${col.value}`"
                                                   :param="col" :form="dialog.form" :cols="cols"></my-select>
                                    </template>
                                    <template v-else-if="col.type === $variable.colType.NEDITOR">
                                        <!--<vue-neditor-wrap ref="neditor" @ready="ready" v-if="ue.finished" v-model="ue.content"-->
                                                          <!--:config="ue.config" :destroy="false"></vue-neditor-wrap>-->
                                    </template>

                                    <template v-else-if="col.type === $variable.colType.FUZZY">
                                        <el-input v-model="dialog.form[col.key]" clearable suffix-icon="el-icon-search" readonly
                                                  @click.native="openFuzzy(col)"></el-input>
                                    </template>
                                    <template v-else-if="col.type === $variable.colType.DATE">
                                        <el-date-picker v-model="dialog.form[col.key]" type="date"
                                                        value-format="yyyy-MM-dd"
                                                        :placeholder="`请选择${col.value}`"></el-date-picker>
                                    </template>
                                    <template v-else-if="col.type === $variable.colType.NUMBER">
                                        <el-input v-model.number="dialog.form[col.key]"
                                                  :placeholder="`请输入${col.value}`"></el-input>
                                    </template>

                                    <template v-else-if="col.type === $variable.colType.IMG">
                                        <ls-upload v-model="dialog.form[col.key]" ></ls-upload>
                                    </template>

                                    <template v-else>
                                        <el-input v-model="dialog.form[col.key]" :placeholder="`请输入${col.value}`"></el-input>
                                    </template>
                                </slot>
                            </el-form-item>
                        </el-col>
                    </template>
                </el-row>
            </el-form>
        </div>

        <div style="padding: 15px 15px 70px; margin-top:-30px">
            <vue-neditor-wrap ref="neditor" @ready="ready" v-if="ue.finished && hasUE" v-model="ue.content"
                              :config="ue.config" :destroy="false"></vue-neditor-wrap>
        </div>

        <div class="btns">
            <el-button class="btn-solid-blue" icon="el-icon-success" :loading="dialog.loading" @click="save">保存</el-button>
            <el-button icon="el-icon-error" @click="dialog.show = false">取消</el-button>
            <template v-if="dialog.isShowDel && isShowDel">
                <el-button class="btn-solid-red" icon="el-icon-delete" :loading="dialog.loading"
                           @click="delEdit">删除
                </el-button>
            </template>
        </div>

        <my-dialog class="common-fuzzy" title="筛选" v-if="fuzzy.show" :show.sync="fuzzy.show"
                   width="800px" hide-footer>
            <component :is="fuzzy.key" :obj="fuzzy.param"></component>
        </my-dialog>
    </my-drawer>
</template>

<script>
    import LsUpload from "@/components/lsUpload";
    export default {
        components: {LsUpload},
        props: {
            // 弹窗相关参数
            dialog: {},

            cols: {},
            isShowDel: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            rules() {
                return this.getRule(this.cols, this.dialog.edit ? 'requiredAdd' : 'requiredUpdate')
            }
        },
        mounted() {
            setTimeout(() => {
                if (this.dialog.isRich) {
                    // this.ue.config.initialFrameWidth = this.$refs.form.$el.clientWidth
                    this.ue.finished = true
                }
            }, 300)
        },
        data() {
            return {
                max: false,
                fuzzy: {
                    key: '',
                    show: false,
                },

                // ue参数
                hasUE: false,
                ue: {
                    finished: false,
                    config: {
                        // 你的UEditor资源存放的路径,相对于打包后的index.html
                        UEDITOR_HOME_URL: process.env.NODE_ENV === 'development' ? '/neditor/' : '/neditor/',
                        // 编辑器不自动被内容撑高
                        autoHeightEnabled: false,
                        // 初始容器高度
                        initialFrameHeight: 350,
                        // 初始容器宽度
                        initialFrameWidth: '100%',
                        // 关闭自动保存
                        enableAutoSave: false
                    },
                    content:'',
                },
            }
        },
        methods: {
            openFuzzy(item) {
                this.fuzzy.key = item.param.key
                this.fuzzy.param = item.param
                this.fuzzy.show = true
            },
            ready() {
                this.hasUE && (this.$refs.neditor.readyValue = this.dialog.form.contentText || '')

            },
            resetFields() {
                this.$refs.form.resetFields();
            },
            getRule(cols, key) {
                let res = {};
                cols.forEach(item => {
                    let arr = item.rule ? item.rule : []
                    if (item.required || item[key]) {
                        arr.push({
                            required: true,
                            message: `请${this.$help.isSelect(item.type) ? '选择' : '输入'}${item.value}`,
                            trigger: item.type === this.$help.isSelect(item.type) ? 'change' : 'blur'
                        })
                    }
                    res[item.key] = arr
                })
                return res
            },

            save() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.$emit('save');
                    }
                })
            },
            delEdit() {
                this.$emit('delEdit');
            },
            changeFullScreen() {
                this.max = !this.max;
            },
            isShow(col) {
                if (col.type === this.$variable.colType.NEDITOR) {
                    return false
                }
                return (!this.dialog.edit && col.viewAdd) || (this.dialog.edit && col.viewEdit) || (col.read && col.viewEdit && this.dialog.edit)
            }
        },
        created(){
            // vue创建对象之后
            // 调用
            // this.$refs.neditor.editor.ready();
            for (let i = 0; i < this.cols.length; i += 1) {
                if (this.cols[i].type === this.$variable.colType.NEDITOR) {
                    this.hasUE = true
                    break
                }
            }
        }
    }
</script>
